var H = require("hogan.js");
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"sma-slideout-block\">");t.b("\n" + i);t.b("	<i class=\"sma-slideout-block-spinner nc-icon-glyph loader_circle-04 spin\"></i>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"sma-slideout-block\">\n\t<i class=\"sma-slideout-block-spinner nc-icon-glyph loader_circle-04 spin\"></i>\n</div>", H);return T.render.apply(T, arguments); };


//////////////////
// WEBPACK FOOTER
// ../apps/chide/products/smapply/static/sma.common/partials/slideout_block.mustache
// module id = 459
// module chunks = 0 3